import { useMutation } from "@tanstack/react-query";

import client from "./client.ts";

import type { Step1CompletedToken } from "@/store/registrationStore.ts";

export interface CreateUserPayload {
	firstName?: string;
	lastName?: string;
	email: string;
	password: string;
	step1CompletedToken?: Step1CompletedToken;
}

export interface SetPasswordPayload {
	email: string;
	password: string;
}

export interface CreateUserResponse {
	redirectUrl: string;
}

export const useCreateOrUpdateUserMutation = () => {
	return useMutation({
		mutationFn: (payload: CreateUserPayload) =>
			client.post<CreateUserResponse>("/registration/createOrUpdateUser", payload)
	});
};

export const useSetPasswordMutation = () => {
	return useMutation({
		mutationFn: (payload: SetPasswordPayload) => client.post("/registration/setPassword", payload)
	});
};
